export const CAREERS_URL = '/careers'
export const TERMS_OF_SERVICE_URL = '/terms-of-service'
export const ACCESSIBILITY_URL = '/accessibility-statement'
export const PRIVACY_POLICY_URL = '/privacy-notice'
export const TOKUSHOHO_URL = '/tokushoho'
export const PET_PORTRAITS_CONTEST_URL = '/pet-portraits-contest'
export const JOIN_US_URL = 'https://mixtiles.dev'
export const IMPRESSUM_URL = '/impressum'
export const DISCOVERY_URL = '/browse'
export const AI_GENERATION_URL = '/photo-to-art'
export const AI_PLACES_URL = 'https://places.mixtiles.com/travel'
export const HOME_AND_HOBBIES_URL =
  'https://welcome.mixtiles.com/home-and-hobbies'
export const AI_KIDS_URL = 'https://kids.mixtiles.com'
export const AI_KITCHEN_ART_URL = 'https://welcome.mixtiles.com/kitchen-art'
export const EXTERNAL_WALL_DESIGNER_URL = 'https://walls.mixtiles.com'
export const AI_VINTAGE_POSTERS_URL =
  'https://welcome.mixtiles.com/vintage-posters'
export const HOME_URL = '/'
export const PHOTO_WALL_URL = '/photo-walls'
export const PHOTO_STYLER_URL = '/photos'
export const PHOTO_STYLER_HOMEPAGE_URL = '/photos/home'
export const LANDING_PAGES_URL = '/l'
export const MY_ORDERS_URL = '/my-orders'
export const ONBOARDING_URL = '/getstarted'
export const ONBOARDING_SMS_URL = `${ONBOARDING_URL}/sms`
export const ONBOARDING_INTRO_URL = `${ONBOARDING_URL}/intro`
export const MINIGAME_URL = '/minigame'
export const GIFT_CARD = '/gift'
export const REFERRAL = '/referral'
export const BUSINESS_PAGE_URL = '/for-business'
export const LOGIN_CALLBACK_URL = '/login-callback'
export const EMBEDDED_LOGIN_URL = '/elogin'
export const INSTAGRAM_URL = 'https://www.instagram.com/mixtiles'
export const FACEBOOK_URL = 'https://www.facebook.com/mixtiles'
export const RECRUITING_COUNTRY = 'IL'
export const POST_PAYMENT_URL = '/post-payment'
export const POST_PAYMENT_QUERY_PATHNAME = 'return_pathname'
export const ART_COLLECTION_ENTRYPOINT_URL = '/collection'
export const ART_COLLECTION_HOME_URL = '/collection/home'
export const ART_COLLECTION_BROWSE_URL = '/collection/browse'
export const YOUTUBE_URL = 'https://www.youtube.com/@mixtiles'
export const TIKTOK_URL = 'https://www.tiktok.com/@mixtiles'
export const PINTEREST_URL = 'https://www.pinterest.com/mixtiles/'
export const PHOTO_BOOK_HOMEPAGE_URL = '/photo-books/home'
export const PHOTO_BOOK_DESIGN_URL = '/photo-books/design'
export const PHOTO_BOOK_LIFE_EVENTS_URL = '/photo-books/life-events'
export const PHOTO_BOOK_URL = '/photo-books'
// A minted book id is at least 8 chars, so no book id can ever equal this segment.
export const NEW_PHOTO_BOOK_SEGMENT = 'new'
export const NEW_PHOTO_BOOK_URL = `${PHOTO_BOOK_URL}/${NEW_PHOTO_BOOK_SEGMENT}`
export const PREFERENCES_SAVED_URL = '/preferences-saved'
export const LINKEDIN_URL = 'https://www.linkedin.com/company/mixtiles'
export const PROD_URL = 'https://www.mixtiles.com'
export const BLOG_URL = '/blog'
export const PRODUCTS_URL = '/products'
export const PRODUCTS_MODE_PARAM = 'mode'
export const ADD_PRODUCT_MODE = 'add-product'
export const ADD_PRODUCT_URL = `${PRODUCTS_URL}?${PRODUCTS_MODE_PARAM}=${ADD_PRODUCT_MODE}`
export const COOKIE_POLICY_URL = '/cookie-policy'
export const ORDER_SUMMARY_V2_URL = '/order-summary'
export const CDN_URL = 'https://assets.mixtiles.com'
export const ART_API_PATH = '/art-api'
